import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl, SafeScript, SafeStyle, SafeUrl } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Injectable()
export class CustomDomSanitizer extends DomSanitizer {
  constructor() {
    super();
  }

  // This is the method ngx-markdown calls to clean the HTML
  override sanitize(context: SecurityContext, value: string | any): string | null {
    if (value === null) return null;

    switch (context) {
      case SecurityContext.HTML:
        return DOMPurify.sanitize(value, {
          ALLOW_DATA_ATTR: true,
          ALLOWED_TAGS: [
            'b',
            'i',
            'em',
            'strong',
            'a',
            'span',
            'ul',
            'ol',
            'li',
            'p',
            'br',
            'pre',
            'code',
            'blockquote',
            'hr',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'img',
            'table',
            'thead',
            'tbody',
            'tr',
            'th',
            'td',
            'svg',
          ],
          ALLOWED_ATTR: ['href', 'title', 'alt', 'src', 'class', 'style', 'data-highlight-id', 'id', 'target', 'rel'],
        });

      case SecurityContext.URL:
      case SecurityContext.RESOURCE_URL:
        if (typeof value === 'string' && value.trim().toLowerCase().startsWith('javascript:')) {
          return 'unsafe:' + value;
        }
        return value;

      default:
        return null;
    }
  }

  bypassSecurityTrustHtml(value: string): SafeHtml {
    return value as SafeHtml;
  }

  bypassSecurityTrustStyle(value: string): SafeStyle {
    return value as SafeStyle;
  }

  bypassSecurityTrustScript(value: string): SafeScript {
    return value as SafeScript;
  }

  bypassSecurityTrustUrl(value: string): SafeUrl {
    return value as SafeUrl;
  }

  bypassSecurityTrustResourceUrl(value: string): SafeResourceUrl {
    return value as SafeResourceUrl;
  }
}
